import { __extends } from "tslib";
import { UntagDeliveryStreamInput, UntagDeliveryStreamOutput } from "../models/index";
import { deserializeAws_json1_1UntagDeliveryStreamCommand, serializeAws_json1_1UntagDeliveryStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UntagDeliveryStreamCommand = /** @class */ (function (_super) {
    __extends(UntagDeliveryStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UntagDeliveryStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UntagDeliveryStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UntagDeliveryStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: UntagDeliveryStreamOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UntagDeliveryStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1UntagDeliveryStreamCommand(input, context);
    };
    UntagDeliveryStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1UntagDeliveryStreamCommand(output, context);
    };
    return UntagDeliveryStreamCommand;
}($Command));
export { UntagDeliveryStreamCommand };
//# sourceMappingURL=UntagDeliveryStreamCommand.js.map